<template lang='pug' src='./GoogleBtn.pug'></template>

<script>
  import Vue from 'vue'

  export default {
    name: 'GoogleBtn',
    data: function () {
      return {
        loginRoute: Vue.config.holidays.LOGIN_ROUTE
      }
    }
  }
</script>

<style lang='css' src='./GoogleBtn.css' scoped></style>



// WEBPACK FOOTER //
// GoogleBtn.vue?2a12b90b